import { apiUrl } from "../config/app";
import ApiService from "./ApiService";

export const fetchUtilityLocations = async (params = {}) => {
  try {
    const apiService = new ApiService();
    const data = await apiService.get(apiUrl + "/utility-locations", params);
    console.log("utility locations fetched ", data?.data?.length);
    return data;
  } catch (err: any) {
    console.log("error on fetchUtilityLocations " + err);
    throw err;
  }
};

export const fetchUtilityLocation = async (id: string = "") => {
  try {
    const apiService = new ApiService();
    const data = await apiService.get(apiUrl + "/utility-locations/" + id);
    console.log("utility location fetched ");
    return { data };
  } catch (err: any) {
    console.log("error on fetchUtilityLocation " + err);
    throw err;
  }
};

export const createUtilityLocation = async (data: any) => {
  try {
    const apiService = new ApiService();
    const resp = await apiService.post(apiUrl + "/utility-locations", data);
    console.log("utility location saved ");
    return resp;
  } catch (err: any) {
    console.log("error on createUtilityLocation " + err);
    throw err;
  }
};

export const updateUtilityLocation = async (id: string, data: any) => {
  try {
    const apiService = new ApiService();
    const resp = await apiService.put(
      apiUrl + "/utility-locations/" + id,
      data,
    );
    console.log("utility location updated ");
    return resp;
  } catch (err: any) {
    console.log("error on updateUtilityLocation " + err);
    throw err;
  }
};

export const deleteUtilityLocation = async (id: string) => {
  try {
    const apiService = new ApiService();
    const resp = await apiService.delete(apiUrl + "/utility-locations/" + id);
    console.log("utility location deleted ");
    return resp;
  } catch (err: any) {
    console.log("error on deleteUtilityLocation " + err);
    throw err;
  }
};
